<script setup lang="ts">
import { computed } from 'vue'
import { useStaticAsset } from '@/composables/useStaticAsset'

const asset = useStaticAsset()

const props = withDefaults(
  defineProps<{
    tab?: string
    size?: number
    active?: boolean
    disabled?: boolean
    demo?: boolean
    warning?: boolean
  }>(),
  {
    size: 48
  }
)

const src = computed(() => {
  const result = [props.tab || '']
  if (props.disabled) result.push('disabled')
  else {
    if (props.active) result.push('active')
    if (props.demo) result.push('demo')
    if (props.warning) result.push('warning')
  }
  const baseName = asset(`img/student-v2/tabs/${result.join('_')}`)
  return {
    webp: `${baseName}.webp 1x, ${baseName}@2x.webp 2x, ${baseName}@3x.webp 3x`,
    png: `${baseName}.png 1x, ${baseName}@2x.png 2x, ${baseName}@3x.png 3x`,
    fallback: `${baseName}.png`
  }
})
</script>

<template>
  <picture>
    <source type="image/webp" :srcset="src.webp" :width="size" :height="size" />
    <source type="image/png" :srcset="src.png" :width="size" :height="size" />
    <img :width="size" :height="size" :src="src.fallback" />
  </picture>
</template>
